export default __webpack_public_path__ + "static/media/apiIcon.00680f6f.png";